import { createAsyncThunk } from '@reduxjs/toolkit';

import { MyInvestmentsService } from 'api';

import { SortPaginationParams } from 'models';

export const getMyFinishedInvestments = createAsyncThunk(
	'myInvestments/getMyFinishedInvestments',
	async (params: SortPaginationParams) => {
		return await MyInvestmentsService.getFinished(params);
	},
);
